import gql from 'graphql-tag';

export default gql`
  query getRoomTypes($includeHidden: Boolean) {
    roomTypes(includeHidden: $includeHidden) {
      id
      isHidden
      type
      alternateName
      oldCode
      logoUrl
      slug
      displayOrder
      packages {
        id
        type
      }
    }
  }
`;
